import { initializeApp } from "firebase";

const app = initializeApp({
  apiKey: "AIzaSyCM-Kuko8TuwG73H0XoxwqSOiNVA_zdjcE",
  authDomain: "mbed-a5059.firebaseapp.com",
  databaseURL: "https://mbed-a5059.firebaseio.com",
  projectId: "mbed-a5059",
  storageBucket: "mbed-a5059.appspot.com",
  messagingSenderId: "304333142439",
  appId: "1:304333142439:web:fde456a37da343b1d25e82",
});

export const db = app.database();
export const storage = app.storage();
